import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const carouselOnPLPCategorySelector = createSelector(testTargetOffersSelector, offers => offers.carouselOnPLPCategory || Empty.Object);

export { carouselOnPLPCategorySelector };
